export const ZOBJECT = 'zobject';
export const ZMESSAGE = 'zmessage';
export const PAD = 'pad';
export const TRACK = 'track';
export const EFFECT = 'effect';
